import { Flex } from '@components';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(10),
  flex: 1,
  flexDirection: 'column',
  gap: theme.spacing(10),
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 'fit-content',
  maxWidth: 1400,
}));

export const StyledImage = styled('img')(() => ({
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
}));
